<div class="welcome-container">
  <div class="welcome-content">
    <h1 class="welcome-title">
      {{ loggedInUser?.fullName ? 'Welcome, ' : 'Welcome' }}
      <span>{{ loggedInUser?.fullName }}</span>
    </h1>

    <p class="welcome-message">
      Welcome to the Lister Portal. Use the sidebar navigation to manage products, listings, customers, and other
      platform activities.
    </p>
  </div>
</div>
